import React from 'react';
import {
  Button,
  ButtonVariant,
  Box,
  Modal,
  useSnackBar,
} from '@usealloy/component-library';
import { removeActionAndResetNodeState } from './NodeDropdownMenu/helpers';
import { useAppDispatch } from '~/store/reduxHooks';

const ConfirmNodeDeletionModal = ({
  nodeDeletionChildActionCounts,
  resetNodeChildActionCounts,
  id,
  isWorkflowHistoryOn,
}: {
  nodeDeletionChildActionCounts: number;
  resetNodeChildActionCounts: () => void;
  id: string;
  isWorkflowHistoryOn: boolean;
}) => {
  const addSnackBar = useSnackBar();
  const dispatch = useAppDispatch();

  return (
    <Modal
      header="Are you sure you want to delete this?"
      isOpen
      hasCloseIcon={false}
      size="small"
      onClose={resetNodeChildActionCounts}
      primaryAction={(
        <Button
          variant={ButtonVariant.primary}
          onClick={() => removeActionAndResetNodeState({
            addSnackBar,
            dispatch,
            isWorkflowHistoryOn,
            nodeId: id,
          })}
        >
          Delete
        </Button>
      )}
      secondaryAction={(
        <Button
          variant={ButtonVariant.secondary}
          onClick={resetNodeChildActionCounts}
        >
          Cancel
        </Button>
      )}
    >
      <Box
        alignItems="flex-start"
        direction="column"
        gap={6}
        justifyContent="flex-start"
      >
        <span>
          This node has {nodeDeletionChildActionCounts} dependent{nodeDeletionChildActionCounts > 1 && 's'}.
          Deleting it will update or delete those{' '}
          dependents in ways that may be undesirable. Are you sure you want to delete?
        </span>
      </Box>
    </Modal>
  );
};

export default ConfirmNodeDeletionModal;
